export default __webpack_public_path__ + "static/media/decada-0090-0004-min.9d8d68f4.jpg";